import React from 'react';
import type IssueTypeSchemesDirectory from '@atlassian/jira-spa-apps-admin-pages-issue-type-schemes-directory/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyIssueTypeSchemesDirectory = lazyForPaint<typeof IssueTypeSchemesDirectory>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-admin-pages-issue-type-schemes-directory", jiraSpaEntry: "async-admin-pages-issue-type-schemes-directory" */ '@atlassian/jira-spa-apps-admin-pages-issue-type-schemes-directory'
		),
	),
);

const AsyncIssueTypeSchemesDirectory = (): React.JSX.Element => (
	<LazyPage
		Page={LazyIssueTypeSchemesDirectory}
		pageId="jira-admin-pages-issue-type-schemes-directory"
		shouldShowSpinner
	/>
);

export default AsyncIssueTypeSchemesDirectory;
